import { Component, NgZone, OnInit } from '@angular/core';
import { LocalSystemService } from '../local-system.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import * as XLSX from 'xlsx';


@Component({
  selector: 'app-deliveries-dealers',
  templateUrl: './deliveries-dealers.component.html',
  styleUrls: ['./deliveries-dealers.component.css']
})
export class DeliveriesDealersComponent implements OnInit {
  sales:any = [];
  currentPage:any = 1;
  total_pages = 0;
  total_pages_array = [];

  searched:any = false;
  search_type:any = "client_name";
  search:any = "";

  timeoutSerialInner:any;

  availableBrands:any = [];
  timeline:any = "0";
  brand:any = "all";
  offices:any = [];
  towns:any = [{"name":"гр.Айтос","region":"Бургас","population":22500},{"name":"гр.Аксаково","region":"Варна","population":8206},{"name":"гр.Алфатар","region":"Силистра","population":1608},{"name":"гр.Антоново","region":"Търговище","population":1437},{"name":"гр.Априлци","region":"Ловеч","population":2867},{"name":"гр.Ардино","region":"Кърджали","population":3973},{"name":"гр.Асеновград","region":"Пловдив","population":52896},{"name":"гр.Ахелой","region":"Бургас","population":2109},{"name":"гр.Ахтопол","region":"Бургас","population":1436},{"name":"гр.Балчик","region":"Добрич","population":12726},{"name":"гр.Банкя","region":"София град","population":11662},{"name":"гр.Банско","region":"Благоевград","population":8170},{"name":"гр.Баня","region":"Пловдив","population":3329},{"name":"гр.Батак","region":"Пазарджик","population":3266},{"name":"гр.Батановци","region":"Перник","population":2230},{"name":"гр.Белене","region":"Плевен","population":8318},{"name":"гр.Белица","region":"Благоевград","population":3184},{"name":"гр.Белово","region":"Пазарджик","population":3876},{"name":"гр.Белоградчик","region":"Видин","population":5452},{"name":"гр.Белослав","region":"Варна","population":8129},{"name":"гр.Берковица","region":"Монтана","population":13708},{"name":"гр.Благоевград","region":"Благоевград","population":75397},{"name":"гр.Бобов дол","region":"Кюстендил","population":6040},{"name":"гр.Бобошево","region":"Кюстендил","population":1330},{"name":"гр.Божурище","region":"Софийска","population":5420},{"name":"гр.Бойчиновци","region":"Монтана","population":1487},{"name":"гр.Болярово","region":"Ямбол","population":1245},{"name":"гр.Борово","region":"Русе","population":2252},{"name":"гр.Ботевград","region":"Софийска","population":21407},{"name":"гр.Брацигово","region":"Пазарджик","population":4262},{"name":"гр.Брегово","region":"Видин","population":2572},{"name":"гр.Брезник","region":"Перник","population":4092},{"name":"гр.Брезово","region":"Пловдив","population":1894},{"name":"гр.Брусарци","region":"Монтана","population":1188},{"name":"гр.Бургас","region":"Бургас","population":206722},{"name":"гр.Бухово","region":"София град","population":2913},{"name":"гр.Българово","region":"Бургас","population":2001},{"name":"гр.Бяла","region":"Варна","population":2263},{"name":"гр.Бяла","region":"Русе","population":8921},{"name":"гр.Бяла Слатина","region":"Враца","population":12627},{"name":"гр.Бяла Черква","region":"Велико Търново","population":2606},{"name":"гр.Варна","region":"Варна","population":348136},{"name":"гр.Велики Преслав","region":"Шумен","population":8937},{"name":"гр.Велико Търново","region":"Велико Търново","population":71156},{"name":"гр.Велинград","region":"Пазарджик","population":24800},{"name":"гр.Ветово","region":"Русе","population":4831},{"name":"гр.Ветрен","region":"Пазарджик","population":3152},{"name":"гр.Видин","region":"Видин","population":51699},{"name":"гр.Враца","region":"Враца","population":62000},{"name":"гр.Вълчедръм","region":"Монтана","population":3568},{"name":"гр.Вълчи дол","region":"Варна","population":3425},{"name":"гр.Върбица","region":"Шумен","population":3595},{"name":"гр.Вършец","region":"Монтана","population":6251},{"name":"гр.Габрово","region":"Габрово","population":60364},{"name":"гр.Генерал Тошево","region":"Добрич","population":6963},{"name":"гр.Главиница","region":"Силистра","population":1881},{"name":"гр.Глоджево","region":"Русе","population":3506},{"name":"гр.Годеч","region":"Софийска","population":4332},{"name":"гр.Горна Оряховица","region":"Велико Търново","population":33156},{"name":"гр.Гоце Делчев","region":"Благоевград","population":20358},{"name":"гр.Грамада","region":"Видин","population":1481},{"name":"гр.Гулянци","region":"Плевен","population":3424},{"name":"гр.Гурково","region":"Стара Загора","population":2996},{"name":"гр.Гълъбово","region":"Стара Загора","population":8675},{"name":"гр.Две могили","region":"Русе","population":4252},{"name":"гр.Дебелец","region":"Велико Търново","population":3919},{"name":"гр.Девин","region":"Смолян","population":6587},{"name":"гр.Девня","region":"Варна","population":9259},{"name":"гр.Джебел","region":"Кърджали","population":3200},{"name":"гр.Димитровград","region":"Хасково","population":39934},{"name":"гр.Димово","region":"Видин","population":1193},{"name":"гр.Добринище","region":"Благоевград","population":2668},{"name":"гр.Добрич","region":"Добрич","population":96881},{"name":"гр.Долна баня","region":"Софийска","population":4793},{"name":"гр.Долна Митрополия","region":"Плевен","population":3417},{"name":"гр.Долна Оряховица","region":"Велико Търново","population":2884},{"name":"гр.Долни Дъбник","region":"Плевен","population":4520},{"name":"гр.Долни чифлик","region":"Варна","population":7056},{"name":"гр.Доспат","region":"Смолян","population":2343},{"name":"гр.Драгоман","region":"Софийска","population":3300},{"name":"гр.Дряново","region":"Габрово","population":8028},{"name":"гр.Дулово","region":"Силистра","population":7063},{"name":"гр.Дунавци","region":"Видин","population":2597},{"name":"гр.Дупница","region":"Кюстендил","population":37416},{"name":"гр.Дългопол","region":"Варна","population":4847},{"name":"гр.Елена","region":"Велико Търново","population":5693},{"name":"гр.Елин Пелин","region":"Софийска","population":7278},{"name":"гр.Елхово","region":"Ямбол","population":10492},{"name":"гр.Етрополе","region":"Софийска","population":10951},{"name":"гр.Завет","region":"Разград","population":3250},{"name":"гр.Земен","region":"Перник","population":1749},{"name":"гр.Златарица","region":"Велико Търново","population":2723},{"name":"гр.Златица","region":"Софийска","population":5018},{"name":"гр.Златоград","region":"Смолян","population":7220},{"name":"гр.Ивайловград","region":"Хасково","population":3685},{"name":"гр.Игнатиево","region":"Варна","population":4288},{"name":"гр.Искър","region":"Плевен","population":3462},{"name":"гр.Исперих","region":"Разград","population":9080},{"name":"гр.Ихтиман","region":"Софийска","population":13591},{"name":"гр.Каблешково","region":"Бургас","population":2898},{"name":"гр.Каварна","region":"Добрич","population":11832},{"name":"гр.Казанлък","region":"Стара Загора","population":50850},{"name":"гр.Калофер","region":"Пловдив","population":2921},{"name":"гр.Камено","region":"Бургас","population":5334},{"name":"гр.Каолиново","region":"Шумен","population":1790},{"name":"гр.Карлово","region":"Пловдив","population":24288},{"name":"гр.Карнобат","region":"Бургас","population":18301},{"name":"гр.Каспичан","region":"Шумен","population":3186},{"name":"гр.Кермен","region":"Сливен","population":1738},{"name":"гр.Килифарево","region":"Велико Търново","population":2365},{"name":"гр.Китен","region":"Бургас","population":1131},{"name":"гр.Клисура","region":"Пловдив","population":1093},{"name":"гр.Кнежа","region":"Плевен","population":11060},{"name":"гр.Козлодуй","region":"Враца","population":13677},{"name":"гр.Койнаре","region":"Плевен","population":4541},{"name":"гр.Копривщица","region":"Софийска","population":2348},{"name":"гр.Костандово","region":"Пазарджик","population":4299},{"name":"гр.Костенец","region":"Софийска","population":6633},{"name":"гр.Костинброд","region":"Софийска","population":11849},{"name":"гр.Котел","region":"Сливен","population":5880},{"name":"гр.Кочериново","region":"Кюстендил","population":2288},{"name":"гр.Кресна","region":"Благоевград","population":3656},{"name":"гр.Криводол","region":"Враца","population":3259},{"name":"гр.Кричим","region":"Пловдив","population":8605},{"name":"гр.Крумовград","region":"Кърджали","population":4943},{"name":"гр.Крън","region":"Стара Загора","population":3382},{"name":"гр.Кубрат","region":"Разград","population":7750},{"name":"гр.Куклен","region":"Пловдив","population":5999},{"name":"гр.Кула","region":"Видин","population":3222},{"name":"гр.Кърджали","region":"Кърджали","population":49326},{"name":"гр.Кюстендил","region":"Кюстендил","population":48135},{"name":"гр.Левски","region":"Плевен","population":10922},{"name":"гр.Летница","region":"Ловеч","population":3483},{"name":"гр.Ловеч","region":"Ловеч","population":37568},{"name":"гр.Лозница","region":"Разград","population":2297},{"name":"гр.Лом","region":"Монтана","population":24522},{"name":"гр.Луковит","region":"Ловеч","population":9583},{"name":"гр.Лъки","region":"Пловдив","population":2402},{"name":"гр.Любимец","region":"Хасково","population":7681},{"name":"гр.Лясковец","region":"Велико Търново","population":8629},{"name":"гр.Мадан","region":"Смолян","population":6578},{"name":"гр.Маджарово","region":"Хасково","population":724},{"name":"гр.Малко Търново","region":"Бургас","population":2397},{"name":"гр.Мартен","region":"Русе","population":3704},{"name":"гр.Мездра","region":"Враца","population":10927},{"name":"гр.Мелник","region":"Благоевград","population":334},{"name":"гр.Меричлери","region":"Хасково","population":1812},{"name":"гр.Мизия","region":"Враца","population":3282},{"name":"гр.Момин проход","region":"Софийска","population":1611},{"name":"гр.Момчилград","region":"Кърджали","population":8317},{"name":"гр.Монтана","region":"Монтана","population":45191},{"name":"гр.Мъглиж","region":"Стара Загора","population":3479},{"name":"гр.Неделино","region":"Смолян","population":4273},{"name":"гр.Несебър","region":"Бургас","population":13710},{"name":"гр.Николаево","region":"Стара Загора","population":3147},{"name":"гр.Никопол","region":"Плевен","population":3907},{"name":"гр.Нова Загора","region":"Сливен","population":24074},{"name":"гр.Нови Искър","region":"София град","population":14005},{"name":"гр.Нови пазар","region":"Шумен","population":13652},{"name":"гр.Обзор","region":"Бургас","population":2480},{"name":"гр.Омуртаг","region":"Търговище","population":9195},{"name":"гр.Опака","region":"Търговище","population":2776},{"name":"гр.Оряхово","region":"Враца","population":5562},{"name":"гр.Павел баня","region":"Стара Загора","population":2843},{"name":"гр.Павликени","region":"Велико Търново","population":10952},{"name":"гр.Пазарджик","region":"Пазарджик","population":77103},{"name":"гр.Панагюрище","region":"Пазарджик","population":17929},{"name":"гр.Перник","region":"Перник","population":79044},{"name":"гр.Перущица","region":"Пловдив","population":5139},{"name":"гр.Петрич","region":"Благоевград","population":31141},{"name":"гр.Пещера","region":"Пазарджик","population":20467},{"name":"гр.Пирдоп","region":"Софийска","population":7536},{"name":"гр.Плачковци","region":"Габрово","population":1811},{"name":"гр.Плевен","region":"Плевен","population":112840},{"name":"гр.Плиска","region":"Шумен","population":1014},{"name":"гр.Пловдив","region":"Пловдив","population":368853},{"name":"гр.Полски Тръмбеш","region":"Велико Търново","population":4586},{"name":"гр.Поморие","region":"Бургас","population":14003},{"name":"гр.Попово","region":"Търговище","population":16047},{"name":"гр.Пордим","region":"Плевен","population":2111},{"name":"гр.Правец","region":"Софийска","population":4321},{"name":"гр.Приморско","region":"Бургас","population":3546},{"name":"гр.Провадия","region":"Варна","population":13145},{"name":"гр.Първомай","region":"Пловдив","population":14091},{"name":"гр.Раднево","region":"Стара Загора","population":13329},{"name":"гр.Радомир","region":"Перник","population":14342},{"name":"гр.Разград","region":"Разград","population":35177},{"name":"гр.Разлог","region":"Благоевград","population":12820},{"name":"гр.Ракитово","region":"Пазарджик","population":8648},{"name":"гр.Раковски","region":"Пловдив","population":15586},{"name":"гр.Рила","region":"Кюстендил","population":2783},{"name":"гр.Роман","region":"Враца","population":3013},{"name":"гр.Рудозем","region":"Смолян","population":3625},{"name":"гр.Русе","region":"Русе","population":160511},{"name":"гр.Садово","region":"Пловдив","population":2407},{"name":"гр.Самоков","region":"Софийска","population":27348},{"name":"гр.Сандански","region":"Благоевград","population":28342},{"name":"гр.Сапарева баня","region":"Кюстендил","population":4128},{"name":"гр.Свети Влас","region":"Бургас","population":4092},{"name":"гр.Свиленград","region":"Хасково","population":18802},{"name":"гр.Свищов","region":"Велико Търново","population":32132},{"name":"гр.Своге","region":"Софийска","population":8084},{"name":"гр.Севлиево","region":"Габрово","population":24558},{"name":"гр.Сеново","region":"Русе","population":1449},{"name":"гр.Септември","region":"Пазарджик","population":8504},{"name":"гр.Силистра","region":"Силистра","population":38364},{"name":"гр.Симеоновград","region":"Хасково","population":6988},{"name":"гр.Симитли","region":"Благоевград","population":7199},{"name":"гр.Славяново","region":"Плевен","population":4351},{"name":"гр.Сливен","region":"Сливен","population":96598},{"name":"гр.Сливница","region":"Софийска","population":7268},{"name":"гр.Сливо поле","region":"Русе","population":3322},{"name":"гр.Смолян","region":"Смолян","population":30785},{"name":"гр.Смядово","region":"Шумен","population":4049},{"name":"гр.Созопол","region":"Бургас","population":5236},{"name":"гр.Сопот","region":"Пловдив","population":9125},{"name":"гр.София","region":"София град","population":1281148},{"name":"гр.Средец","region":"Бургас","population":9161},{"name":"гр.Стамболийски","region":"Пловдив","population":11662},{"name":"гр.Стара Загора","region":"Стара Загора","population":149439},{"name":"гр.Стражица","region":"Велико Търново","population":5323},{"name":"гр.Стралджа","region":"Ямбол","population":6349},{"name":"гр.Стрелча","region":"Пазарджик","population":4226},{"name":"гр.Суворово","region":"Варна","population":5054},{"name":"гр.Сунгурларе","region":"Бургас","population":3292},{"name":"гр.Сухиндол","region":"Велико Търново","population":1996},{"name":"гр.Съединение","region":"Пловдив","population":5788},{"name":"гр.Сърница","region":"Пазарджик","population":3590},{"name":"гр.Твърдица","region":"Сливен","population":6082},{"name":"гр.Тервел","region":"Добрич","population":6764},{"name":"гр.Тетевен","region":"Ловеч","population":10185},{"name":"гр.Тополовград","region":"Хасково","population":5474},{"name":"гр.Троян","region":"Ловеч","population":22179},{"name":"гр.Трън","region":"Перник","population":2552},{"name":"гр.Тръстеник","region":"Плевен","population":4536},{"name":"гр.Трявна","region":"Габрово","population":9621},{"name":"гр.Тутракан","region":"Силистра","population":9567},{"name":"гр.Търговище","region":"Търговище","population":39836},{"name":"гр.Угърчин","region":"Ловеч","population":2731},{"name":"гр.Хаджидимово","region":"Благоевград","population":2702},{"name":"гр.Харманли","region":"Хасково","population":19617},{"name":"гр.Хасково","region":"Хасково","population":77365},{"name":"гр.Хисаря","region":"Пловдив","population":7264},{"name":"гр.Цар Калоян","region":"Разград","population":3742},{"name":"гр.Царево","region":"Бургас","population":6268},{"name":"гр.Чепеларе","region":"Смолян","population":5332},{"name":"гр.Червен бряг","region":"Плевен","population":13958},{"name":"гр.Черноморец","region":"Бургас","population":2186},{"name":"гр.Чипровци","region":"Монтана","population":1835},{"name":"гр.Чирпан","region":"Стара Загора","population":16517},{"name":"гр.Шабла","region":"Добрич","population":3488},{"name":"гр.Шивачево","region":"Сливен","population":3833},{"name":"гр.Шипка","region":"Стара Загора","population":1355},{"name":"гр.Шумен","region":"Шумен","population":89365},{"name":"гр.Ябланица","region":"Ловеч","population":2799},{"name":"гр.Якоруда","region":"Благоевград","population":5512},{"name":"гр.Ямбол","region":"Ямбол","population":77150}]

  modal:any = { open:false, cntx:"", obj:{} }

  purchase_date_picker:any = false;  
  current_purchase_date:any;
  current_purchase_month_dates:any = [];
  installation_date_picker:any = false;
  current_installation_date:any;
  current_installation_month_dates:any = [];
  storage:any;

  constructor(public system:LocalSystemService, private http:HttpClient, private router:Router, private ngZone:NgZone) {
    // if(this.system.returnRole() > 1 && this.system.returnRole() < 3 && !this.system.returnIsAdmin()) { this.router.navigate(['/warranties']); }
    this.getAvailableBrands();
    this.getSales();
    this.getOffices();
    let sales_search_obj = JSON.parse(localStorage.getItem('sales_search_obj'));
    if(sales_search_obj == null) {
      localStorage.setItem('sales_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_type, 'search':this.search }));
    } else {
      if(sales_search_obj['searched']) {
        this.currentPage = sales_search_obj['page'];
        this.searched = true;
        this.search_type = sales_search_obj['search_type'];
        this.search = sales_search_obj['search'];
        this.openModal('loading-sales', {});
        this.http.get("api/service.php?action=search_sales&page=" + this.currentPage + "&search_type=" + this.search_type + "&search=" + this.search).subscribe((data) => {
          this.sales = data['sales'];
          this.total_pages = data['total_pages'];
          this.total_pages_array = [];
          for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
          this.closeModal();
        });
      } else {
        if(sales_search_obj['page'] != undefined) {this.currentPage = sales_search_obj['page']; } 
        else { this.currentPage = 1; }
        this.getSales();
      }
    }
  }

  ngOnInit(): void {
  }

  switchSaleExpanded(sale){
    if(!sale.expanded) {
      for(let i = 0; i < this.sales.length; i++) {
        this.sales[i].expanded = false;
      }
    }
    sale.expanded = !sale.expanded;
    if(sale.expanded) {
      this.http.get("api/service.php?action=get_sale_products&sale_id=" + sale.uid).subscribe((data) => {
        sale.items = data['products'];
      });
    }
  }

  getSales() {
    this.sales = [];
    this.openModal('loading-sales', {})
    let url = "api/service.php?action=get_sales&page=" + this.currentPage;
    if(this.brand != 'all') { url += "&by_brand=" + this.brand; }
    if(this.timeline != '0') { url += "&by_date=" + this.timeline; }
    this.http.get(url).subscribe((data) => {
      if(data['logged']) {
        this.sales = data['sales'];
        this.total_pages = data['total_pages'];
        this.total_pages_array = [];
        for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
        this.ngZone.run(()=> {});
        setTimeout(()=>{
          this.closeModal();
          localStorage.setItem('sales_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_type, 'search':this.search }));
        }, 500);
      } else {
        this.system.Logout();
      }
    });
  }

  getExportSales() {
    this.openModal('exporting-sales', this.modal.obj);
    this.http.get("api/service.php?action=export_sales&start_date=" + this.returnDateFormatedForExport(this.modal.obj.start_date) + "&end_date=" + this.returnDateFormatedForExport(this.modal.obj.end_date) + "&search_type=" + this.search_type + "&search=" + this.search).subscribe((data) => {
      let products = data['products'];
      var worksheet = XLSX.utils.json_to_sheet(products);
       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    
       /* save to file */  
       let dt = new Date();
       XLSX.writeFile(wb, "Продажби"+ this.returnDateFormated(this.modal.obj.start_date) +"-"+ this.returnDateFormated(this.modal.obj.end_date) +".xlsx");
       this.closeModal();

    });
  }

  exportSale(sale) {
    this.openModal('exporting-sales', this.modal.obj);
    this.http.get("api/service.php?action=export_sale&uid=" + sale.uid + "&date_sale=" + sale.date_of_sale).subscribe((data) => {
      let products = data['products'];
      for(var pi = 0; pi < products.length; pi++) {
        delete products[pi]['Фактура'];
      }
      var worksheet = XLSX.utils.json_to_sheet(products);
       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    
       /* save to file */  
       let dt = new Date();
       let old_date = new Date();
       XLSX.writeFile(wb, "Продажби"+ this.returnDateFormated(old_date) +"-.xlsx");
       this.closeModal();

    });
  }

  searchSales() {
    this.currentPage = 1;
    this.searched = true;
    this.openModal('loading-sales', {});
    this.http.get("api/service.php?action=search_sales&page=" + this.currentPage + "&search_type=" + this.search_type + "&search=" + this.search).subscribe((data) => {
      this.sales = data['sales'];
      this.total_pages = data['total_pages'];
      this.total_pages_array = [];
      for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
      this.closeModal();
      localStorage.setItem('sales_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_type, 'search':this.search }));
    });
  }
  switchPageSearch() {
    this.openModal('loading-sales', {})
    this.http.get("api/service.php?action=search_sales&page=" + this.currentPage + "&search_type=" + this.search_type + "&search=" + this.search).subscribe((data) => {
      this.sales = data['sales'];
      this.total_pages = data['total_pages'];
      this.total_pages_array = [];
      for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
      this.closeModal();
      localStorage.setItem('sales_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_type, 'search':this.search }));
    });
  }
  clearSearched() { 
    this.searched = false; 
    this.search_type = "serial_number";
    this.search = "";
    this.currentPage = 1;
    this.getSales();
  }

  switchedFilter() { this.getSales(); }

  getAvailableBrands() {
    this.http.get("api/service.php?action=get_brands").subscribe((data) => {
      this.availableBrands = data['brands'];
    });
  }

  getOffices() {
    this.http.get("api/service.php?action=get_offices").subscribe((data) => {
      this.offices = data['offices'];
    });
  }


  promptDelete(uid, date_of_sale) { this.openModal('remove-sale', { 'uid':uid, 'date_of_sale':date_of_sale }); }
  deleteSale(uid, date_of_sale) {
    let params = { 'uid':uid, 'date_of_sale':date_of_sale }
    this.http.post("api/service.php?action=remove_sale", params).subscribe((data) => {
      this.closeModal();
      this.getSales();
    });
  }

  createWarranty(sale_id, client_name, client_address, client_phone, client_email, service_id, service_address, service_phone, client_town, date_purchase,date_installation) {
    let params = { 'sale_id':sale_id, "client_name":client_name, 'client_address':client_address, 'town':client_town, 'date_purchase':date_purchase, 'date_installation':date_installation, 'client_phone':client_phone, "client_email":client_email, "service_id":service_id, "service_address":service_address, "service_phone":service_phone }
    this.http.post("api/service.php?action=create_warranty_from_sale", params).subscribe((data) => {
      this.closeModal();
      this.getSales();
    });
  }

  openModal(cntx, obj) { 
    if(cntx == 'export-sale') {
      obj.start_date = new Date();
      obj.end_date = new Date();
      obj.current_start_date = new Date();
      obj.current_end_date = new Date();
      obj.dates = [];
    }
    this.modal = { open:true, 'cntx':cntx, 'obj':obj};
    if(cntx == 'add-warranty') {
      if(this.offices.length > 0) { 
        this.modal.obj.service_id = this.offices[0].uid; 
        this.modal.obj.service_address = this.offices.filter(office => office.uid == parseInt(this.modal.obj.service_id))[0].address;
        this.modal.obj.service_phone = this.offices.filter(office => office.uid == parseInt(this.modal.obj.service_id))[0].phone;
      }
      this.modal.obj.date_purchase = new Date();
      this.modal.obj.date_installation = new Date();

      this.current_purchase_date = this.modal.obj.date_purchase;
      this.current_installation_date = this.modal.obj.date_installation;
    }else if(cntx == 'export-sale') {
      this.Formulate(this.modal.obj.start_date);
    }
   } 
  closeModal() { this.modal = { open:false, cntx:"", obj:{} }; }

  checkService() {
      if(this.modal.obj.service_id != '-1') {
        this.modal.obj.service_address = this.offices.filter(office => office.uid == parseInt(this.modal.obj.service_id))[0].address;
        this.modal.obj.service_phone = this.offices.filter(office => office.uid == parseInt(this.modal.obj.service_id))[0].phone;
      } else {
        this.openModal('add-office', { address:"", phone:"", old_obj:this.modal.obj });
      }
  }

  prePrintWarranty(sale) {
    window.location.href = 'http://warranty.tempex.bg/preprint.php?warranty_id=' + sale.warranty_id;
  }


  switchPage(page) {
    this.currentPage = page;
    if(!this.searched) { this.getSales(); }
    else { this.switchPageSearch(); }
  }

  deselectTown() {
    setTimeout(()=>{
      this.modal.obj.selectingTown = false
    }, 500);
  }

  selectTown(town) {
    this.modal.obj.town = town.name;
    this.modal.obj.selectingTown = false;
  }

  openDateEndPicker() {
    this.timeoutSerialInner = setTimeout(()=>{      
      this.modal.obj.end_picker = true; 
      this.modal.obj.current_end_date = new Date(this.modal.obj.end_date);
      this.Formulate(this.modal.obj.current_end_date);
    }, 50);
  }

  selectStartDate(dt){
    this.modal.obj.start_date.setYear(this.modal.obj.current_start_date.getFullYear());
    this.modal.obj.start_date.setDate(dt.date);
    this.modal.obj.start_date.setMonth(dt.month);
    this.modal.obj.start_picker = false;
  }

  prevMonth(dt) { dt.setMonth(dt.getMonth() - 1); this.Formulate(dt); }
  nextMonth(dt) { dt.setMonth(dt.getMonth() + 1); this.Formulate(dt); }

  openDateStartPicker() {
    this.timeoutSerialInner = setTimeout(()=>{      
      this.modal.obj.start_picker = true; 
      this.modal.obj.current_start_date = new Date(this.modal.obj.start_date);
      this.Formulate(this.modal.obj.current_start_date);
    }, 50);
  }

  selectEndDate(dt){
    this.modal.obj.end_date.setYear(this.modal.obj.current_end_date.getFullYear());
    this.modal.obj.end_date.setDate(dt.date);
    this.modal.obj.end_date.setMonth(dt.month);
    this.modal.obj.end_picker = false;
  }

  Formulate(dt) {
    this.modal.obj.dates = [];

    var firstDay = new Date(dt.getFullYear(), dt.getMonth(), 1);
    var lastDay = new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
    let predate_num = 0;
    // GENERATE PREDATE

    for(let i = 0; i < 42 - lastDay.getDate(); i++) {
        let day_idx = i;
        let first_day = firstDay.getDay();
        if(first_day == 0) { first_day = 7; }
        if(day_idx < first_day - 1) {
            let negative_day = day_idx * -1;
            let date_reformed = new Date(dt.getFullYear(), dt.getMonth(), negative_day);
            this.modal.obj.dates.unshift({ "date": date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false})
            predate_num += 1;
        }
    }
    for(let i = 0; i < lastDay.getDate(); i++) {
        let day_id = i + 1;
        this.modal.obj.dates.push({ "date":day_id, "month":dt.getMonth(), "active":true });
    }
    for(let i = 0; i < 42 - lastDay.getDate() - predate_num; i++) {
        let date_reformed = new Date(dt.getFullYear(), dt.getMonth() + 2, i + 1);
        this.modal.obj.dates.push({ "date":date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false });
    }
  }

  nextInstallationMonth() { this.current_installation_date.setMonth(this.current_installation_date.getMonth() + 1); this.Formulate(this.current_installation_date); }
  prevInstallationMonth() { this.current_installation_date.setMonth(this.current_installation_date.getMonth() - 1); this.Formulate(this.current_installation_date); }

  addOffice() {
    let params = { 'address':this.modal.obj.address, 'phone':this.modal.obj.phone }
    this.http.post("api/service.php?action=add_office", params).subscribe((data) => {
      this.getOffices();
      this.openModal('add-warranty', this.modal.obj.old_obj);
    });
  }

  backFromOffice() {
    this.openModal('add-warranty', this.modal.obj.old_obj);
  }

  backStorageProduct(uid, serial, sale_id) {
    let params = { 'uid':uid, 'serial':serial, 'sale_id':sale_id };
    this.http.post("api/service.php?action=return_product", params).subscribe((data) => {
      if(data['removed_whole']) {
        this.getSales();
      } else {
        this.http.get("api/service.php?action=get_sale_products&sale_id=" + sale_id).subscribe((dt) => {
          this.sales.filter(sale => sale.uid == sale_id)[0].items = dt['products'];
        });
      }
      this.closeModal();
    });
  }


  returnDateFormatedForStorage(dt) {
    return dt.getFullYear() + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + this.returnPadZero(dt.getDate(), 2) +  " " +  this.returnPadZero(dt.getHours(), 2) + ":" + this.returnPadZero(dt.getMinutes(), 2) + ":" + this.returnPadZero(dt.getSeconds(), 2);
  }

  returnDateFormatedForExport(dt) {
    return dt.getFullYear() + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + this.returnPadZero(dt.getDate(), 2);
  }


  returnDateFormated(dt){
    return this.returnPadZero(dt.getDate(), 2) + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + dt.getFullYear();
  }

  returnYear(dt) { return dt.getFullYear(); }
  returnMonth(dt) { return dt.getMonth() + 1; }
  returnMonthName(month) {
    if(month == 1) { return "Януари"; }
    else if(month == 2) { return "Февруари"; }
    else if(month == 3) { return "Март"; }
    else if(month == 4) { return "Април"; }
    else if(month == 5) { return "Май"; }
    else if(month == 6) { return "Юни"; }
    else if(month == 7) { return "Юли"; }
    else if(month == 8) { return "Август"; }
    else if(month == 9) { return "Септември"; }
    else if(month == 10) { return "Октомври"; }
    else if(month == 11) { return "Ноември"; }
    else if(month == 12) { return "Декември"; }
    else { return ""; }
  }
  returnDate(dt) { return dt.getDate();  }

  returnPadZero(number, length) {
    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }

  returnFilteredTown() {
    return this.towns.filter(town => town.name.toLowerCase().indexOf(this.modal.obj.town.toLowerCase()) > -1);
  }
}
